import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useSEO, buildCanonical } from "@/lib/seo";

/**
 * Legacy URL handler. Emergent's ingress cannot serve a true 301 for
 * non-/api paths, so we do the strongest SPA-level equivalent:
 *  - a canonical pointing at the new URL (consolidates the SEO signals),
 *  - an immediate client-side redirect,
 *  - a visible fallback link for crawlers/users without JS.
 */
export default function EventRedirect({ to = "/evenements", hash = "", label }) {
  const { lang, localePath } = useI18n();
  const navigate = useNavigate();
  const target = `${localePath(to)}${hash}`;

  useSEO({
    canonical: buildCanonical(to),
    lang,
  });

  useEffect(() => {
    const t = setTimeout(() => navigate(target, { replace: true }), 250);
    return () => clearTimeout(t);
  }, [navigate, target]);

  return (
    <div data-testid="legacy-redirect" className="px-6 md:px-12 lg:px-16">
      <section className="py-32 max-w-2xl mx-auto text-center">
        <p className="overline">{lang === "en" ? "Page moved" : "Page déplacée"}</p>
        <p className="mt-6 text-[#697585]">
          {lang === "en" ? "Redirecting you to " : "Redirection vers "}
          <Link to={target} className="text-[#B8956A] underline underline-offset-4">
            {label || to}
          </Link>
          …
        </p>
      </section>
    </div>
  );
}
